import { format } from 'date-fns';

class MetadataOnSave {
    
    elements = {};

    constructor(elements = {}) {
        this.elements = { ...elements };
    }
    
    /*
    onStateChange = (changedElements) => {
        if(this.elements.hasOwnProperty("channelname") && changedElements.hasOwnProperty("channelname")) {
            console.log(this.elements.channelname, changedElements.channelname);
            if(this.elements.channelname !== changedElements.channelname) {
                if(changedElements.channelname === "ITV1") {
                    console.log("THERE");
                    changedElements.summary = "SUMMARY"
                }
            }
        }
        
        return changedElements;
    }
    */
}

export default MetadataOnSave;


